import React, { useEffect, useState } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import "./PhaseMaster.css";
import { Link, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  getPhaseDataUrl,
  PhaseExportToExcel,
} from "../../../Helpers/API/APIEndPoints";
import Heading from "../../../Components/Heading/Heading";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import fileDownload from "js-file-download";
import axios from "axios";
import { Tooltip } from "antd";

const PhaseMaster = () => {
  let navigate = useNavigate();

  const [phaseData, setPhaseData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [isactive, setIsActive] = useState("active");
  //   {
  //     "phase": "Phase1",
  //     "description": "This is test phase 1",
  //     "engagementId": 1,
  //     "plannedDate": "2022-06-15T00:00:00",
  //     "actualDate": "2022-06-15T00:00:00",
  //     "sortColumn": null,
  //     "sortDirection": null,
  //     "pageSize": 0,
  //     "start": 0,
  //     "searchText": null,
  //     "engagement": null,
  //     "taskMasters": [],
  //     "ticketsMasters": [],
  //     "id": 1,
  //     "isActive": true,
  //     "createdDate": "2022-06-15T16:40:17.707",
  //     "createdBy": 1,
  //     "modifiedDate": "2022-06-15T16:40:17.707",
  //     "modifiedBy": 1
  // },

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "phase",
      label: "Name",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagementName",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;

          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <Link to={"edit"} state={id} className="action_icon">
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </Link>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  useEffect(() => {
    localStorage.clear();   //deepak gupta
    (async () => {
      let requestParams = {
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        searchText: searchText,
        activeStatusId: isactive,
      };
      // console.log('req obj=|>',requestParams)
      const { data } = await APICall(getPhaseDataUrl, "POST", requestParams);
      // console.log('Phase data===>',data);
      setPhaseData(data.phaseMasterData);
      //setCount(data.count);
      setCount(data.phaseMasterData ? data.phaseMasterData[0].totalCount : 0);
    })();
  }, [start, sortColumn, sortDirection, searchText, isactive]); //isactive

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

  const ExportToExcel = async () => {
    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: PhaseExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: {
          searchText: searchText,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
          master: "phase",
          activeStatusId: isactive,
        },
      })
      .then((response) => {
        fileDownload(response.data, "Phase Report.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };
  return (
    <>
      <Heading title={"Phase Master"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
            <div>
              <Link to={"edit"} className="btn btn-update">
                Create
              </Link>
              </div>
              <div>
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={phaseData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PhaseMaster;
